export default __webpack_public_path__ + "static/media/ic_calendar.ae6b7519.svg";